/**
 * Search Bar
 *
 * @module search-bar
 */

const component = {

    /**
     * Init module
     * 
     * @returns {undefined}
     */
	init: () => {

        component.target = document.querySelector('[data-search-bar-header]');

        if (!component.target)
            return false;

        component.initFocusTrap();
        component.initToggle();
	},

    /**
     * Init toggle buttons
     * 
     * @returns {undefined}
     */
    initToggle: () => {

        // Open button
        document.querySelectorAll('[data-search-open]').forEach((element) => {

            element.addEventListener('click', (event) => {
                event.preventDefault();
                component.enableOverlay();
                component.open();
            });
        });

        // Close button
        component.target.querySelector('[data-search-close]').addEventListener('click', (event) => {
            event.preventDefault();
            component.close();
        });

        // Close search bar when click on the overlay
        component.target.querySelectorAll('[data-search-overlay-close]').forEach(element => {
            element.addEventListener('click', event => {
                event.preventDefault();
                component.close();
            });
        });

        // Close search on window resize
        window.addEventListener('screen-breakpoint', event => {
            component.close();
        });

        // Close search on press escape
        window.addEventListener('escape', event => {
            component.close();
        });
    },

    /**
     * Open search bar
     * 
     * @returns {undefined}
     */
    open: () => {
        document.querySelector('.site-header').classList.add('search-active');
        component.target.classList.add('active');
        document.querySelector('[data-search-input]').focus();
        component.openStatus = true;
        component.activeFocusTrap();
        
        // remove scroll to body
        document.body.style.overflow = 'hidden';
    },

    /**
     * Close search bar
     * 
     * @returns {undefined}
     */
    close: () => {
        component.disableFocusTrap();
        document.querySelector('.site-header').classList.remove('search-active');
        component.target.classList.remove('active');
        component.disableOverlay();
        
        // add scroll to body
        document.body.style.overflow = 'auto';

        if (component.openStatus) {
            document.querySelector('[data-search-open]').focus();
        }

        component.openStatus = false;
    },

    /**
     * Init search bar focus trap
     * 
     * @returns {undefined}
     */
     initFocusTrap: () => {

        component.focusTrap = focusTrap.createFocusTrap(component.target, { allowOutsideClick: true });
    },

    /**
     * Disable search bar focus trap
     * 
     * @returns {undefined}
     */
     disableFocusTrap: () => {

        if (component.focusTrap) {
            component.focusTrap.deactivate();
        }
    },

    /**
     * Ative search bar focus trap
     * 
     * @returns {undefined}
     */
    activeFocusTrap: () => {

        if (component.focusTrap) {
            component.focusTrap.activate();
        }
    },

    /**
	 * Enable global overlay
     * 
     * @return {undefined}
	 */
    enableOverlay: () => {
        let overlay = component.target.querySelector('[data-search-overlay-close]');

        if (overlay) {
            overlay.classList.remove('hidden');
        }
    },

    /**
	 * Disable global overlay
     * 
     * @return {undefined}
	 */
    disableOverlay: () => {
        let overlay = component.target.querySelector('[data-search-overlay-close]');

        if (overlay) {
            overlay.classList.add('hidden');
        }
    }
};

export default component;
